import { render, staticRenderFns } from "./createMassCampaigns.vue?vue&type=template&id=c83e815c&scoped=true&"
import script from "./createMassCampaigns.vue?vue&type=script&lang=js&"
export * from "./createMassCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./createMassCampaigns.vue?vue&type=style&index=0&id=c83e815c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e815c",
  null
  
)

export default component.exports